import { AttractionTranslationsList } from '@/components/attractions/translations';
import { useParams } from 'react-router-dom';

export function AttractionTranslationsTab() {
  const { id } = useParams<{ id: string }>();

  if (!id) return null;

  return <AttractionTranslationsList attractionId={id} className="p-0" />;
}
